import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Interactable from '../../Component/Interactable';
import AnimationComponent from '../../Component/Animation';
import Point from '../../Utility/Point';

export default class SurpriseCard extends GameObject {
    protected onCreate(params: any): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable);
        this.addComponent<Interactable>(Interactable, {
            enabled: true,
            buttonMode: true,
        });
        this.addComponent<AnimationComponent>(AnimationComponent, {
            playOnStart: true,
            clipName: 'SurpriseCardShowUp',
        });

        const surprise = GameObject.Instantiate(Sprite, {
            texture: 'Suprise_Card',
            anchor: new Point(0.5, 0.5),
        });
        this.addChild(surprise);

        const backcard = GameObject.Instantiate(Sprite, {
            texture: params.texture,
            position: new Point(0, 2),
            anchor: new Point(0.5, 0.5),
            scale: new Point(1.25, 1.25),
            visible: false,
        });
        this.addChild(backcard);
    }
}
